import { PaymentMethodType } from '../../constants/lookups';
import { CreditCard } from './credit-card';

export class PaymentMethod {
    paymentMethodType: PaymentMethodType;
    creditCard: CreditCard;
}
